import { reactive, ref } from 'vue';
import { MEDIA_TYPES } from '@/types/enums';

const currentDialogsSkeletons = reactive<any>({});
const currentFolderSkeletons = reactive<any>({});
const currentCasePhotoSkeletons = reactive<any>({});
const currentCaseFileSkeletons = reactive<any>({});
const photoSkeletons = ref(0);
const mixedSkeletons = ref(0);

export default class SkeletonService {
  public static setDialogSkeletons(id: string, amount: number, type: MEDIA_TYPES): void {
    if (currentDialogsSkeletons[id]) {
      currentDialogsSkeletons[id] += amount;
    } else {
      currentDialogsSkeletons[id] = amount;
    }

    mixedSkeletons.value += amount;
    if (type !== MEDIA_TYPES.FILES) {
      photoSkeletons.value += amount;
    }
  }

  public static removeDialogSkeletons(id: string, amount: number, type: MEDIA_TYPES): void {
    currentDialogsSkeletons[id] = currentDialogsSkeletons[id] - amount < 0 ? 0 : currentDialogsSkeletons[id] - amount;
    mixedSkeletons.value = mixedSkeletons.value - amount < 0 ? 0 : mixedSkeletons.value - amount;
    if (type !== MEDIA_TYPES.FILES) {
      photoSkeletons.value = photoSkeletons.value - amount < 0 ? 0 : photoSkeletons.value - amount;
    }
  }

  public static setFolderSkeletons(id: string, amount: number, type: MEDIA_TYPES): void {
    if (currentFolderSkeletons[id]) {
      currentFolderSkeletons[id] += amount;
    } else {
      currentFolderSkeletons[id] = amount;
    }
    if (type !== MEDIA_TYPES.FILES) {
      photoSkeletons.value += amount;
    }
  }

  public static removeFolderSkeletons(id: string, amount: number, type: MEDIA_TYPES): void {
    currentFolderSkeletons[id] = currentFolderSkeletons[id] - amount < 0 ? 0 : currentFolderSkeletons[id] - amount;
    if (type !== MEDIA_TYPES.FILES) {
      photoSkeletons.value = photoSkeletons.value - amount < 0 ? 0 : photoSkeletons.value - amount;
    }
  }

  public static setCaseSkeletons(id: string, amount: number, type: MEDIA_TYPES): void {
    mixedSkeletons.value += amount;
    if (type !== MEDIA_TYPES.FILES) {
      if (currentCasePhotoSkeletons[id]) {
        currentCasePhotoSkeletons[id] += amount;
      } else {
        currentCasePhotoSkeletons[id] = amount;
      }
      photoSkeletons.value += amount;
    } else if (currentCaseFileSkeletons[id]) {
      currentCaseFileSkeletons[id] += amount;
    } else {
      currentCaseFileSkeletons[id] = amount;
    }
  }

  public static removeCaseSkeletons(id: string, amount: number, type: MEDIA_TYPES): void {
    mixedSkeletons.value = mixedSkeletons.value - amount < 0 ? 0 : mixedSkeletons.value - amount;
    if (type !== MEDIA_TYPES.FILES) {
      photoSkeletons.value = photoSkeletons.value - amount < 0 ? 0 : photoSkeletons.value - amount;
      currentCasePhotoSkeletons[id] = currentCasePhotoSkeletons[id] - amount < 0 ? 0 : currentCasePhotoSkeletons[id] - amount;
    } else {
      currentCaseFileSkeletons[id] = currentCaseFileSkeletons[id] - amount < 0 ? 0 : currentCaseFileSkeletons[id] - amount;
    }
  }

  public static setPhotoSkeletons(amount: number):void {
    photoSkeletons.value += amount;
  }

  public static removePhotoSkeletons(amount: number):void {
    photoSkeletons.value = photoSkeletons.value - amount < 0 ? 0 : photoSkeletons.value - amount;
  }

  public static setMixedSkeletons(amount: number): void {
    mixedSkeletons.value += amount;
  }

  public static removeMixedSkeletons(amount: number): void {
    mixedSkeletons.value = mixedSkeletons.value - amount < 0 ? 0 : mixedSkeletons.value - amount;
  }

  public static getSkeletonInfo() {
    return ({
      currentDialogsSkeletons,
      currentFolderSkeletons,
      currentCasePhotoSkeletons,
      currentCaseFileSkeletons,
      photoSkeletons,
      mixedSkeletons,
    });
  }
}
